module.exports = __webpack_public_path__ + "img/crm-heatmap.8abc899d.svg";